import FieldObservations from '@/models/field-observations'
import { ProductionTypes } from '@/models/Production'
import aliasStore from './alias-store'
import assetMap from './asset-map-store'
import cacheStore from './cache-store'
import companyAdmin from './company-admin-store'
import detailStore from './detail-store'
import facilityDetail from './facility-detail-store'
import store from './global'
import listStore from './list-store'
import meterDetail from './meter-detail-store'
import notifications from './notifications'
import pipelineDetail from './pipeline-detail-store'
import reportingUnitDetail from './reporting-unit-detail-store'
import tabStore from './tab-store'
import timeSeries from './time-series'
import wellDetail from './well-detail-store'

store.registerModule('WellList', listStore)
store.registerModule('WellTypeHistoryList', listStore)
store.registerModule('WellStatusHistoryList', listStore)
store.registerModule('FieldList', listStore)
store.registerModule('MeterList', listStore)
store.registerModule('MeterAliasList', listStore)
store.registerModule('OperatorAliasList', listStore)
store.registerModule('MeterInterestList', listStore)
store.registerModule('MeterXrefList', listStore)
store.registerModule('AddMeterList', listStore)
store.registerModule('EditMeterList', listStore)
store.registerModule('MeterFacilityHistoryList', listStore)
store.registerModule('MeterWellHistoryList', listStore)
store.registerModule('MeterPipelineHistoryList', listStore)
store.registerModule('MeterStringProductionHistoryList', listStore)
store.registerModule('WellboreList', listStore)
store.registerModule('WellboreTypeHistoryList', listStore)
store.registerModule('WellboreStatusHistoryList', listStore)
store.registerModule('ProductionList', listStore)
store.registerModule('AnalysisGasList', listStore)
store.registerModule('AnalysisWaterList', listStore)
store.registerModule('FacilityXrefList', listStore)
store.registerModule('FacilityList', listStore)
store.registerModule('TenantList', listStore)
store.registerModule('AccountList', listStore)
store.registerModule('JobList', listStore)
store.registerModule('ReportingUnitList', listStore)
store.registerModule('ReportingUnitMeterList', listStore)
store.registerModule('ReportingUnitXrefList', listStore)
store.registerModule('ReportingUnitWellList', listStore)
store.registerModule('ReportingUnitWellboreList', listStore)
store.registerModule('ReportingUnitFacilityList', listStore)
store.registerModule('ReportingUnitPipelineList', listStore)
store.registerModule('ReportingUnitStringProductionList', listStore)
store.registerModule('FormulaReportingUnitList', listStore)
store.registerModule('EditCreateFormulaReportingUnitList', listStore)
store.registerModule('FormulaRuMeterList', listStore)
store.registerModule('FormulaRuRuList', listStore)
store.registerModule('FormulaBoxChipsList', cacheStore)
store.registerModule('PipelineList', listStore)
store.registerModule('PipelineSegmentList', listStore)
store.registerModule('PipelineInterestList', listStore)
store.registerModule('PipelineAliasList', listStore)
store.registerModule('ReportList', listStore)
store.registerModule('ReportRunList', listStore)
store.registerModule('MeterDetail', meterDetail)
store.registerModule('WellDetail', wellDetail)
store.registerModule('OrganizationDetail', detailStore)
store.registerModule('WellInterestList', listStore)
store.registerModule('WellAliasList', listStore)
store.registerModule('WellArtificialLifts', listStore)
store.registerModule('WellboreDetail', detailStore)
store.registerModule('FacilityDetail', facilityDetail)
store.registerModule('FacilityInterestList', listStore)
store.registerModule('FacilityAliasList', listStore)
store.registerModule('PipelineDetail', pipelineDetail)
store.registerModule('ReportingUnitDetail', reportingUnitDetail)
store.registerModule('ReportingUnitAliasList', listStore)
store.registerModule('AllocationDetail', detailStore)
store.registerModule('AllocationSetList', listStore)
store.registerModule('AllocationResultList', listStore)
store.registerModule('OperatorList', listStore)
store.registerModule('AssetMap', assetMap)
store.registerModule('CompanyAdmin', companyAdmin)
store.registerModule('JobInfo', tabStore)
store.registerModule('ReportInfo', tabStore)
store.registerModule('PressureReadingList', listStore)
store.registerModule('CompanyInformationInfo', tabStore)
store.registerModule('OperatorAlias', aliasStore)
store.registerModule('Notifications', notifications)
store.registerModule('StringProductionList', listStore)
store.registerModule('StringProductionDetail', detailStore)
store.registerModule('StringProductionTypeHistoryList', listStore)
store.registerModule('StringProductionStatusHistoryList', listStore)
store.registerModule('PressureTimeSeries', timeSeries)
store.registerModule('AnalysisGasTimeSeries', timeSeries)

Object.keys(FieldObservations.assets).forEach(key => {
  FieldObservations.assets[key].observations.forEach(item => {
    store.registerModule(`FieldObservation${key}${item.type}List`, listStore)
  })
})

Object.keys(ProductionTypes).forEach(key => {
  store.registerModule(`Production${(ProductionTypes as any)[key]}TimeSeries`, timeSeries)
})

export default store
